import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/react-hooks';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import {
  HANDLE_ACTIVITY_BOOKING,
  HANDLE_ACCOMMODATION_BOOKING
} from 'graphql/mutations/booking';

import useStyles from './styles';

const mutationsConfig = {
  Activity: HANDLE_ACTIVITY_BOOKING,
  Accommodation: HANDLE_ACCOMMODATION_BOOKING
};

function HandledCell({ booking, isHandledBooking, refetch }) {
  const classes = useStyles();
  const [t] = useTranslation();

  const [isHandled, setIsHandled] = React.useState(isHandledBooking);
  const [open, setOpen] = React.useState(false);

  const [handleBooking] = useMutation(mutationsConfig[booking.bookingType]);

  const handleClose = e => {
    e.stopPropagation();
    setOpen(false);
  };

  const handleOpen = e => {
    e.stopPropagation();
    setOpen(true);
  };

  const changeBookingHandledValue = (id, value) => {
    setIsHandled(value);
    booking.isHandled = value;
    handleBooking({ variables: { id: id, isHandled: value } })
      .then(() => refetch())
      .catch();
  };

  return (
    <FormControl className={classes.formControl}>
      <Select
        value={isHandled}
        open={open}
        onClose={e => handleClose(e)}
        onOpen={e => handleOpen(e)}
        className={classes.selectInput}
        onChange={event => {
          changeBookingHandledValue(booking.id, event.target.value);
        }}
      >
        <MenuItem value={true}>{t('Handled')}</MenuItem>
        <MenuItem value={false}>{t('Not handled')}</MenuItem>
      </Select>
    </FormControl>
  );
}

export default HandledCell;
